import {StoritevEnum} from '../Enum/StoritevEnum'

export default class ShieldService {
  /**
   * @type {number | null}
   * @private
   */
  _idCustomer = null
  /**
   * @type {number | null}
   * @private
   */
  _terminationPointId = null
  /**
   * @type {number | null}
   * @private
   */
  _id = null
  /**
   * @type {number | null}
   * @private
   */
  _groupId = null
  /**
   * @type {number | null}
   * @private
   */
  _groupTypeId = null
  /**
   * @type {string | null}
   * @private
   */
  _title = null
  /**
   * @type {string | null}
   * @private
   */
  _description = null
  /**
   * @type {string | null}
   * @private
   */
  _description2 = null
  /**
   * @type {number | null}
   * @private
   */
  _payment = null
  /**
   * @type {number | null}
   * @private
   */
  _price = null
  /**
   * @type {number | null}
   * @private
   */
  _quantity = null
  /**
   * @type {number | null}
   * @private
   */
  _maxConnectedMobiles = null
  /**
   * @type {string}
   * @private
   */
  _icons = ''
  /**
   * @type {boolean | null}
   * @private
   */
  _includedInPackage = null
  /**
   * @type {boolean | null}
   * @private
   */
  _reducedPackage = null
  /**
   * @type {Date | null}
   * @private
   */
  _dateActivated = null
  /**
   * @type {string | null}
   * @private
   */
  _disabledMessage = null
  /**
   * @type {string | null}
   * @private
   */
  _buttonTitle = null
  /**
   * @type {ShieldService | null}
   * @private
   */
  _automaticDiscountService = null

  static createFromResponseItem (item, idCustomer, idTerminationPoint) {
    let out = new this()
    out._idCustomer = idCustomer
    out._terminationPointId = idTerminationPoint
    out._id = item.id
    out._groupId = item.groupId
    out._groupTypeId = item.groupTypeId
    out._title = item.title
    out._description = item.description
    out._description2 = item.description2
    out._price = item.price
    out._quantity = item.quantity
    out._maxConnectedMobiles = item.maxConnectedMobiles
    out._includedInPackage = item.includedInPackage
    out._reducedPackage = item.reducedPackage
    out._dateActivated = item.dateActivated === null ? null : new Date(item.dateActivated.date)
    out._disabledMessage = item.disabledMessage
    out._buttonTitle = item.buttonTitle
    if (item.automaticDiscountService !== null) {
      out._automaticDiscountService = this.createFromResponseItem(item.automaticDiscountService)
    }
    out._payment = item.payment
    switch (item.id) {
      case StoritevEnum.SCITFIX:
        out._icons = '<img src="/static/img/Ikone_Scit/circleNet.png">'
        break
      case StoritevEnum.SCITMOB:
        out._icons = '<img src="/static/img/Ikone_Scit/mobile.png">'
        break
      case StoritevEnum.SCITPAKET:
        out._icons = '<img src="/static/img/Ikone_Scit/circleNet.png" class="pr-1">' +
          '<img src="/static/img/Ikone_Scit/mobile.png">'
        break
    }
    return out
  }

  get idCustomer () {
    return this._idCustomer
  }

  set idCustomer (value) {
    this._idCustomer = value
  }

  get terminationPointId () {
    return this._terminationPointId
  }

  set terminationPointId (value) {
    this._terminationPointId = value
  }

  get id () {
    return this._id
  }

  set id (value) {
    this._id = value
  }

  get groupId () {
    return this._groupId
  }

  set groupId (value) {
    this._groupId = value
  }

  get groupTypeId () {
    return this._groupTypeId
  }

  set groupTypeId (value) {
    this._groupTypeId = value
  }

  get title () {
    return this._title
  }

  set title (value) {
    this._title = value
  }

  get description () {
    return this._description
  }

  set description (value) {
    this._description = value
  }

  get description2 () {
    return this._description2
  }

  set description2 (value) {
    this._description2 = value
  }

  get price () {
    return this._price
  }

  set price (value) {
    this._price = value
  }

  get quantity () {
    return this._quantity
  }

  set quantity (value) {
    this._quantity = value
  }

  get maxConnectedMobiles () {
    return this._maxConnectedMobiles
  }

  set maxConnectedMobiles (value) {
    this._maxConnectedMobiles = value
  }

  get icons () {
    return this._icons
  }

  set icons (value) {
    this._icons = value
  }

  get includedInPackage () {
    return this._includedInPackage
  }

  set includedInPackage (value) {
    this._includedInPackage = value
  }

  get reducedPackage () {
    return this._reducedPackage
  }

  set reducedPackage (value) {
    this._reducedPackage = value
  }

  get dateActivated () {
    return this._dateActivated
  }

  set dateActivated (value) {
    this._dateActivated = value
  }

  get disabledMessage () {
    return this._disabledMessage
  }

  set disabledMessage (value) {
    this._disabledMessage = value
  }

  get buttonTitle () {
    return this._buttonTitle
  }

  set buttonTitle (value) {
    this._buttonTitle = value
  }
  get automaticDiscountService () {
    return this._automaticDiscountService
  }

  set automaticDiscountService (value) {
    this._automaticDiscountService = value
  }

  get payment () {
    return this._payment
  }

  set payment (value) {
    this._payment = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/T2Shield/ShieldService.js